<script>
import entreprise from '../../../assets/icons/ic-entreprise.svg'
import {VueSvgIcon} from "@yzfe/vue3-svgicon";
import ic_enterprise from "@/assets/icons/ic_society-small.svg";
import { createService } from "@/component/cdevs/allFunctions";

export default {
  name: 'AffectationPopup',
    components:{
      // VueSvgIcon,
    },
  data() {
    return {
      icons: { entreprise, ic_enterprise },
      name: '',
      description: null,
      email: ''
    };
  },
  emits: ['closeCreate'],  // Ajouter l'événement 'showSecondPopup'
  props: {
    showPopup2: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    closeCreate() {
      this.$emit('closeCreate');
    },

    // Function to create new accountant
    async saveService() {
        if (this.name === '' || this.description === '' || this.email === '') {
          return this.$toast.error('Veuillez remplir tous les champs')
        }
        this.charge = true;
        const data = {
          apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
          title: this.name,
          description: this.description,
          ownersEmail: [this.email],
        }
        await createService(data).then(response => {
          console.log(response)
          this.charge = false;
          this.$toast.success('Nouveau service ajouté avec succès');
          this.$emit('closeCreate', true)
        }).catch(error => {
          console.log(error)
          this.charge = false;
          this.$toast.error('Une erreur est survenue');
        })
      },
  },
}
</script>

<template>
  <div
    class="popup-overlay"
  >
    <div class="popup-content bg-white w-1/3 py-5 relative">
      <div class="flex font-c7 text-c22 colorBorderB pb-5 px-5">
        Nouveau service
      </div>
      <div class="mt-5">
        <div class="font-c4 text-base mx-5">
          <div class="mb-2 text-left text-82">
            Nom du service
          </div>
          <div class="input-bloc relative">
            <input
              v-model="name"
              type="text"
              class="h-14 bgInpout w-full rounded-10 pl-5"
              placeholder="Ex: Crédit croissance PME"
            >
          </div>
        </div>
        <div class="font-c4 text-base mx-5 my-5">
          <div class="mb-2 text-left text-82">
            Description du service
          </div>
          <div class="input-bloc relative">
            <textarea
              v-model="description"
              type="text"
              class="h-40 bgInpout w-full rounded-10 pl-5 py-2"
              placeholder="Ex: Crédit croissance PME"
            />
          </div>
        </div>
        <div class="font-c4 text-base mx-5">
          <div class="mb-2 text-left text-82">
            Email de redirection
          </div>
          <div class="input-bloc relative">
            <input
              v-model="email"
              type="email"
              class="h-14 bgInpout w-full rounded-10 pl-5"
              placeholder="notification@cci.bj"
            >
          </div>
        </div>
        <div class="flex justify-end items-center mt-5 mx-5">
          <div
            class="font-c5 text-red-500 mt-2 text-sm ml-5 cursor-pointer annulerr px-7 py-3 rounded-8"
            @click="closeCreate"
          >
            Annuler
          </div>
          <div
            class="text-red-500 mt-2 text-sm ml-5 cursor-pointer save px-10 py-3 rounded-8 text-white"
            @click="saveService()"
          >
            Enregistrer
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.annulerr{
    background-color: #EFF4FB;
}
.save{
    background-color: #241A72;
}
.colorBorderB{
    border-bottom: 3px solid #E7EEF8;
}
.bgInpout{
    /* background-color: #F0F2F7; */
    border: 1px solid #F0F2F7
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.popup-content {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 25rem;
}
.relative {
  position: relative;
}
</style>
